var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.21 1.29a1 1 0 00-1.42 0l-13 13.05-13-13a1.016 1.016 0 10-1.5 1.37l13.05 13-13 13a1 1 0 000 1.42.998.998 0 001.42 0l13-13 13 13.05a.999.999 0 001.42 0 1 1 0 000-1.42l-13-13 13.05-13a1 1 0 00-.02-1.47z",
    fill: "#212121"
  })));
}

export default SvgDelete;